// src/services/azurePartnersService.js
// Azure Table Storage Service für Partner/Organisationen

const AZURE_CONFIG = {
  storageAccount: "mfprojects",
  tableName: "projectPartners", // Bestehende Tabelle verwenden!
  sasToken: "sv=2024-11-04&ss=t&srt=sco&sp=rwdlacu&se=2035-07-04T17:08:25Z&st=2025-07-04T09:08:25Z&spr=https&sig=X7s%2BFIyYcKvRzSxRNAp5BUJEe2YUcg8nojkn9fIfcTY%3D"
};

// Helper functions for data cleaning
const cleanValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return String(value);
};

// Hilfsfunktion für eindeutige IDs
const generatePartnerId = () => {
  return `partner_${Date.now()}`;
};

// Alle Partner laden (ORIGINAL FUNKTION)
export const getAllPartners = async () => {
  try {
    const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}?${AZURE_CONFIG.sasToken}`;

    const response = await fetch(url, {
      headers: { Accept: "application/json;odata=nometadata" }
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Azure Error:", errorText);
      throw new Error(`Azure Table Error: ${response.status}`);
    }

    const data = await response.json();
    
    // Konvertiere Azure Table Format zu Frontend Format mit CRM-Erweiterungen
    const partners = data.value.map(item => ({
      id: item.RowKey,
      name: item.Name,
      type: item.Type,
      address: item.Address || '',
      website: item.Website || '',
      description: item.Description || '',
      // CRM-Felder mit Fallbacks
      email: item.Email || '',
      phone: item.Phone || '',
      addressStrasse: item.AddressStrasse || item.Address || '',
      addressPlz: item.AddressPlz || '',
      addressOrt: item.AddressOrt || '',
      addressLand: item.AddressLand || 'Schweiz',
      tags: item.Tags || '',
      notes: item.Notes || '',
      createdAt: item.CreatedAt,
      updatedAt: item.UpdatedAt
    }));

    return partners;
  } catch (error) {
    console.error("Load Partners Error:", error);
    return [];
  }
};

// Einzelnen Partner laden
export const getPartner = async (partnerId) => {
  try {
    const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}(PartitionKey='partner',RowKey='${partnerId}')?${AZURE_CONFIG.sasToken}`;

    const response = await fetch(url, {
      headers: { Accept: "application/json;odata=nometadata" }
    });

    if (response.status === 404) {
      return null;
    }

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Azure Table Error: ${response.status}`);
    }

    const item = await response.json();
    
    return {
      id: item.RowKey,
      name: item.Name,
      type: item.Type,
      address: item.Address || '',
      website: item.Website || '',
      description: item.Description || '',
      email: item.Email || '',
      phone: item.Phone || '',
      addressStrasse: item.AddressStrasse || item.Address || '',
      addressPlz: item.AddressPlz || '',
      addressOrt: item.AddressOrt || '',
      addressLand: item.AddressLand || 'Schweiz',
      tags: item.Tags || '',
      notes: item.Notes || '',
      createdAt: item.CreatedAt,
      updatedAt: item.UpdatedAt
    };
  } catch (error) {
    console.error("Load Partner Error:", error);
    return null;
  }
};

// Partner erstellen (ORIGINAL FUNKTION)
export const createPartner = async (partnerData) => {
  try {
    const partnerId = generatePartnerId();
    const now = new Date().toISOString();

    // Validate required fields
    if (!partnerData.name) {
      throw new Error('Name ist erforderlich');
    }

    const entity = {
      PartitionKey: "partner",
      RowKey: partnerId,
      Name: cleanValue(partnerData.name),
      Type: cleanValue(partnerData.type || 'Organisation'),
      Address: cleanValue(partnerData.addressStrasse || partnerData.address || ''),
      Website: cleanValue(partnerData.website),
      Description: cleanValue(partnerData.description),
      // CRM-Felder
      Email: cleanValue(partnerData.email),
      Phone: cleanValue(partnerData.phone),
      AddressStrasse: cleanValue(partnerData.addressStrasse || ''),
      AddressPlz: cleanValue(partnerData.addressPlz || ''),
      AddressOrt: cleanValue(partnerData.addressOrt || ''),
      AddressLand: cleanValue(partnerData.addressLand || 'Schweiz'),
      Tags: cleanValue(partnerData.tags),
      Notes: cleanValue(partnerData.notes),
      CreatedAt: now,
      UpdatedAt: now
    };

    const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}(PartitionKey='partner',RowKey='${partnerId}')?${AZURE_CONFIG.sasToken}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json;odata=nometadata"
      },
      body: JSON.stringify(entity)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Azure Error Details:', errorText);
      throw new Error(`Azure Save Error: ${response.status} - ${errorText}`);
    }

    return {
      id: partnerId,
      ...partnerData,
      createdAt: now,
      updatedAt: now
    };
  } catch (error) {
    console.error("Create Partner Error:", error);
    throw error;
  }
};

// Partner aktualisieren (ORIGINAL FUNKTION)
export const updatePartner = async (partnerId, partnerData) => {
  try {
    const now = new Date().toISOString();

    // Validate required fields
    if (!partnerData.name) {
      throw new Error('Name ist erforderlich');
    }

    const entity = {
      PartitionKey: "partner",
      RowKey: partnerId,
      Name: cleanValue(partnerData.name),
      Type: cleanValue(partnerData.type || 'Organisation'),
      Address: cleanValue(partnerData.addressStrasse || partnerData.address || ''),
      Website: cleanValue(partnerData.website),
      Description: cleanValue(partnerData.description),
      // CRM-Felder
      Email: cleanValue(partnerData.email),
      Phone: cleanValue(partnerData.phone),
      AddressStrasse: cleanValue(partnerData.addressStrasse || ''),
      AddressPlz: cleanValue(partnerData.addressPlz || ''),
      AddressOrt: cleanValue(partnerData.addressOrt || ''),
      AddressLand: cleanValue(partnerData.addressLand || 'Schweiz'),
      Tags: cleanValue(partnerData.tags),
      Notes: cleanValue(partnerData.notes),
      UpdatedAt: now
    };

    const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}(PartitionKey='partner',RowKey='${partnerId}')?${AZURE_CONFIG.sasToken}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json;odata=nometadata"
      },
      body: JSON.stringify(entity)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Azure Error Details:', errorText);
      throw new Error(`Azure Update Error: ${response.status} - ${errorText}`);
    }

    return {
      id: partnerId,
      ...partnerData,
      updatedAt: now
    };
  } catch (error) {
    console.error("Update Partner Error:", error);
    throw error;
  }
};

// Partner löschen (ORIGINAL FUNKTION)
export const deletePartner = async (partnerId) => {
  try {
    const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}(PartitionKey='partner',RowKey='${partnerId}')?${AZURE_CONFIG.sasToken}`;

    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "If-Match": "*"
      }
    });

    if (!response.ok && response.status !== 404) {
      const errorText = await response.text();
      throw new Error(`Azure Delete Error: ${response.status} - ${errorText}`);
    }

    return true;
  } catch (error) {
    console.error("Delete Partner Error:", error);
    throw error;
  }
};

// Partner nach Typ laden
export const getPartnersByType = async (type) => {
  try {
    const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}?${AZURE_CONFIG.sasToken}&$filter=Type eq '${type}'`;

    const response = await fetch(url, {
      headers: { Accept: "application/json;odata=nometadata" }
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Azure Table Error: ${response.status}`);
    }

    const data = await response.json();
    
    const partners = data.value.map(item => ({
      id: item.RowKey,
      name: item.Name,
      type: item.Type,
      address: item.Address || '',
      website: item.Website || '',
      description: item.Description || '',
      createdAt: item.CreatedAt,
      updatedAt: item.UpdatedAt
    }));

    return partners;
  } catch (error) {
    console.error("Load Partners by Type Error:", error);
    return [];
  }
};

// Partner nach Name suchen
export const searchPartners = async (searchTerm) => {
  try {
    // Note: Azure Table Storage doesn't support LIKE queries
    // We'll load all and filter client-side for simplicity
    const allPartners = await getAllPartners();
    
    const searchLower = searchTerm.toLowerCase();
    return allPartners.filter(partner => 
      partner.name.toLowerCase().includes(searchLower) ||
      partner.description.toLowerCase().includes(searchLower)
    );
  } catch (error) {
    console.error("Search Partners Error:", error);
    return [];
  }
};

// Konfiguration aktualisieren
export const updateConfig = (newConfig) => {
  Object.assign(AZURE_CONFIG, newConfig);
};